export const drugStoreSteps = [
    {
        step: 1,
        label: "Store Information",
        component: "store-info",
        holder: "storeInfo"
    },
    {
        step: 2,
        label: "Personal Information",
        component: "personal-info",
        holder: "personalInfo"
    },
    {
        step: 3,
        label: "Store Schedule",
        component: "schedule-details",
        holder: "scheduleInfo"
    },
    {
        step: 4,
        label: "In Charge Personel",
        component: "personel-details",
        holder: "personelInCharge",
        showSkipButton: true,
        isPharmacist: true
    },
    {
        step: 5,
        label: "Assistant Personel",
        component: "personel-details",
        holder: "personelAssistant",
        showSkipButton: true,
        isPharmacist: false
    },
    {
        step: 6,
        label: "Uploads Document",
        component: "document-details",
        holder: "documentDetails"
    }
]
    
export const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
export const App_Url = process.env.MIX_AWS_URL + '/';
export const Omni_Url = process.env.MIX_OMNI_URL + '/';
export const Base_Url = process.env.MIX_APP_URL + '/';
export const App_Name = process.env.MIX_APP_NAME;
export const App_Env = process.env.MIX_APP_ENV;
export const Valid_Resendable_Codes = ['PPD500', 'GR004', 'GR008', 'GR023', 'GR027', 'GR040', 'RM003']
export const CURRENCY = 'PHP ';
export const Publication_Edition = window.PUBLICATION_EDITION;
export const GSM_CHARACTERS = window.GSM_CHARACTERS;
export const TFD_Url = process.env.MIX_TFD_WEB_URL;
export const TINYMCE_API_KEY = window.TINYMCE_API_KEY;
export const Team_Doctor_Invite_Url = process.env.MIX_TEAM_DOCTOR_INVITE_URL;
export const IMAGE_DIMENSION_LIMIT = 1900;
export const PROFILE = window.PROFILE;

//ANNOUNCEMENT
export const POPULATE_RECIPIENT_LIMIT_PER_JOB = window.POPULATE_RECIPIENT_LIMIT_PER_JOB ?? 2000;
export const ANNOUNCEMENT_SCHEDULE_GRACE_PERIOD = window.ANNOUNCEMENT_SCHEDULE_GRACE_PERIOD ?? 30;
export const POPULATE_RECIPIENT_LIMIT_IN_SEC = 120;
export const SEND_RECIPIENT_LIMIT = 1000;
export const SEND_RECIPIENT_LIMIT_IN_SEC = 2;

export const DEFAULT_PERMISSION = {
    CAN_DELETE: 'delete information',
    CAN_EDIT: 'edit information',
    CAN_ADD: 'add information',
    CAN_VIEW: 'view information',
    CAN_APPROVE: 'approve information',
    CAN_DISBURSEMENT: 'disbursement information',
    CAN_VIEW_CONSULTATION: 'consultation information',
    CAN_VIEW_PRESCRIPTION: 'prescription information',
    CAN_VIEW_DIAGNOSTIC: 'diagnostic prescription information',
    CAN_VIEW_MED_CERT: 'medical certificate information',
    CAN_RESEND_CONSENT: 'resend consent information',
    CAN_VIEW_DISCOUNT: 'purchase discount information',
    CAN_VIEW_PRC_IMAGE: 'prc information',
    CAN_VIEW_SIGNATURE: 'signature information',
    CAN_VIEW_PIN: 'pin information',
    CAN_VIEW_TRANSACTION: 'transaction information',
    CAN_UPDATE: 'update information',
    CAN_CREATE: 'create information',
}

export const STATUS = {
    ACTIVATED: 'activated',
    PENDING: 'pending',
    APPROVED: 'approved',
    CONSULTATION: 'consultation',
    DECLINED: 'declined',
    CANCELLED: 'cancelled',
    EXPIRED: 'expired',
    PAID: 'paid',
    UNPAID: 'unpaid',
    REFUNDED: 'refunded',
    DELETED: 'deleted',
    FAILED: 'failed',
    DONE: 'done',
    SENT: 'sent',
    TELECONSULTATION: 'teleconsultation',
    QUEUED: 'queued',
    BOUNCED: 'bounced',
    TRANSACTION_PENDING: 'transaction_pending',
    FOR_APPROVAL: 'for approval',
    ACCEPTED: 'accepted',
    SERVED: 'served',
    ON_GOING: 'on_going',
    SUSPENDED: 'suspended',
    ON_HOLD: 'on-hold',
    RESCHEDULE: 'reschedule',
    ACTIVE: 'active',
    LABORATORY: 'laboratory',
    INACTIVE: 'inactive',
    OTHERS: 'others',
    FOR_DELETION: 'for deletion',
    FOR_SENDING: 'for_sending',
    SENDING: 'sending',
}

export const PAGINATION = {
    PAGEOPTIONS: [10, 20, 50, 100]
}

export const DRUG_INTERACTION = {
    TYPES: [
        { value: "1", text: "Generic to Generic Interaction" },
        { value: "2", text: "Generic to Section Interaction" },
        { value: "3", text: "Generic to Food Interaction" },
        { value: "4", text: "Section to Section Interaction" },
        { value: "5", text: "Section to Food Interaction" },
        { value: "6", text: "Drug Class to Drug Class Interaction" },
        { value: "7", text: "Drug Class to Generic Interaction" },
        { value: "8", text: "Drug Class to Section Interaction" },
        { value: "9", text: "Drug Class to Food Interaction" }
    ],
    CATEGORIES: [
        { value: "1", text: "Minor" },
        { value: "2", text: "Moderate" },
        { value: "3", text: "Major" }
    ]

}

export const DIRECTORY_TYPE = [
    { value: "generic", text: "Generic" },
    { value: "company", text: "Company" },
    { value: "therapeutic_class", text: "Therapeutic Class" },
    { value: "disease", text: "Disease" },
    { value: "brand", text: "Brand" },
    { value: "device", text: "Device" }
]

export const BRAND_STATUS = [
        { value: 1, text: "Full Listing + ERX" },
        { value: 2, text: "Print Only + ERX" },
        { value: 3, text: "Digital Only + ERX" },
        { value: 4, text: "Unpaid + ERX" },
        { value: 5, text: "Delisted" },
        { value: 6, text: "Phase-Out" },
        { value: 7, text: "Full Listing" },
        { value: 8, text: "Print Only" },
        { value: 9, text: "Digital Only" },
        { value: 10, text: "Unpaid" },
        { value: 11, text: "ERX Only" },       
        { value: 12, text: "Unlisted" }
];

export const TRANSACTION_STATUS = [
    { value: "paid", text: "Paid" },
    { value: "failed", text: "Failed" },
    { value: "transferred", text: "Transferred" },
    { value: "pending", text: "Pending" },
    { value: "transaction_pending", text: "Transaction Pending" }
];

export const BRAND_STATUS_FOR_PRINT = [1, 2, 7, 8];
export const BRAND_STATUS_FOR_DIGITAL = [1, 3, 7, 9];
export const BRAND_STATUS_FOR_ACTIVE_BRANDS = [1, 2, 3, 7, 8, 9];
export const UNPAID_TRANSACTION_STATUS = ['pending', 'transaction_pending', 'failed'];

export const ORDER_STATUS = [
    { value: "failed", text: "Failed", background: "#F50E15", color: "text-white", sequence: 0},
    { value: "pending_payment", text: "Pending Payment", background: "#676767", color: "text-white", sequence: 0},
    { value: "pending", text: "Pending", background: "#676767", color: "text-white", sequence: 0},
    { value: "paid", text: "To Prepare", background: "#F8A812", color: "text-white", sequence: 1 },
    { value: "preparing", text: "Preparing", background: "#F87312", color: "text-white", sequence: 2 },
    { value: "in-transit", text: "In-Transit", background: "#3399FF", color: "text-white", sequence: 3 },
    { value: "to-receive", text: "To Receive", background: "#321FDB", color: "text-white", sequence: 4 },
    { value: "completed", text: "Completed", background: "#2EB85C", color: "text-white", sequence: 5 },
    { value: "cancelled", text: "Cancelled", background: "#d44950", color: "text-white", sequence: 6},
    { value: "all", text: "All", background: "#EBEDEF", color: "text-dark", sequence: 0 },
];

export const COD_ORDER_STATUS = [
    { value: "pending_payment", text: "To Prepare", background: "#F8A812", color: "text-white", sequence: 1 },
    { value: "preparing", text: "Preparing", background: "#F87312", color: "text-white", sequence: 2 },
    { value: "in-transit", text: "In-Transit", background: "#3399FF", color: "text-white", sequence: 3 },
    { value: "completed", text: "Completed", background: "#2EB85C", color: "text-white", sequence: 5 },
    { value: "cancelled", text: "Cancelled", background: "#d44950", color: "text-white", sequence: 6}
];

export const DAYS = [
    { value: 1, text: "Monday" },
    { value: 2, text: "Tuesday" },
    { value: 3, text: "Wednesday" },
    { value: 4, text: "Thursday" },
    { value: 5, text: "Friday" },
    { value: 6, text: "Saturday" },
    { value: 7, text: "Sunday" }
];

export const MONTHS = [
    { value: 1, text: "January" },
    { value: 2, text: "February" },
    { value: 3, text: "March" },
    { value: 4, text: "April" },
    { value: 5, text: "May" },
    { value: 6, text: "June" },
    { value: 7, text: "July" },
    { value: 8, text: "August" },
    { value: 9, text: "September" },
    { value: 10, text: "October" },
    { value: 11, text: "November" },
    { value: 12, text: "December" }
];

export const FULFILLMENT_STATUS = [
    { value: 'fulfilled', text: "Fulfilled", background: "success" },
    { value: 'unfulfilled', text: "Unfulfilled", background: "primary" },
    { value: 'partial_fulfilled', text: "Partial Fulfilled", background: "warning" },
    { value: null, text: "N/A", background: "dark" }
];

export const DHAP = {
    DIMENSIONS: [
        { value: "all", text: "All" },
        { value: "druginfo-form", text: "By form" },
        { value: "druginfo-peso-value", text: "Peso value by form" },
        { value: "demo-md-specialty-clinic-hospital", text: "MD specialty by productivity and by clinic and hospital" },
        { value: "demo-px-indication-profile", text: "Indication and patient profile" },
        { value: "demo-md-age-range", text: "MD age range" },
        { value: "demo-md-yrs-practice", text: "MD years of practice" },
        { value: "demo-md-gender", text: "MD gender" },
        { value: "demo-px-age", text: "Patient's age range" },
        { value: "demo-px-gender", text: "Patient's gender" },
        { value: "geo-4-marketing-regions", text: "4 marketing regions" },
        { value: "geo-6-key-regions", text: "6 key regions" },
        { value: "geo-17-regions", text: "17 regions" },
        { value: "geo-82-provinces", text: "82 provinces" },
        { value: "geo-metro-manila", text: "Metro Manila Cities" },
        { value: "tech-user-device", text: "User device (mobile, desktop, tablet)" },
        { value: "demo-indication-specialty", text: "Indications by Specialties" },
        { value: "demo-specialty-indication", text: "Specialties by Indications" },
        { value: "indication-groups", text: "Indication Groups" },
        { value: "specialty-groups", text: "Specialty Groups" }
    ]
};

export const ADVERTISEMENT = {
    TYPES: [
        { value: "foot_ad", text: "Footer Ads" },
        { value: "head_ad", text: "Header Ads" },
        { value: "title_ad", text: "Title Ads" },
        { value: "default", text: "Default" },
        { value: "marketplace", text: "Marketplace" },
        { value: "spotlight", text: "Spotlight" },
        { value: "health_answer", text: "Health Answer" },
        { value: "billboard1", text: "Billboard1" },
        { value: "billboard2", text: "Billboard2" },
        { value: "youtube", text: "Youtube" },
        { value: "splash_ad", text: "Splash Ad" },
        { value: "cpm_half_banner", text: "CPM Half Banner" },
        { value: "middle_banner", text: "Middle Banner" },
        { value: "billboard3", text: "Billboard3" }
    ],
    PLATFORMS: [
        { value: "eprescription", text: "PPD Clinic" },
        { value: "ppd-patient", text: "PPD Patient" },
        { value: "tfd", text: "TheFilipinoDoctor" }
    ],
    DISPLAYS: [
        { value: "default", text: "Default" },
        { value: "doctor", text: "Doctor" },
        { value: "dentist", text: "Dentist" },
        { value: "bmp", text: "BMP" },
    ],
    CHANNELS: [
        { value: "email", text: "Email" },
        { value: "push_notif", text: "Push Notification" },
        { value: "sms", text: "SMS" }
    ],
    SEGMENTATION_KEYS: [
        {
            text: 'Region',
            value: 'region_id',
            component_name: 'region',
            track_name: 'name',
            type: 'multiselect',
            category: 'geo'
        },
        {
            text: 'Province',
            value: 'province_id',
            component_name: 'province',
            track_name: 'province_name',
            type: 'multiselect',
            category: 'geo'
        },
        {
            text: 'Municipality/City',
            value: 'municipality_id',
            component_name: 'municipality',
            track_name: 'municipality_name',
            type: 'multiselect',
            category: 'geo'
        },
        {
            text: 'Specialty',
            value: 'specialty_id',
            component_name: 'specialty',
            track_name: 'specialty_name',
            type: 'multiselect',
            category: 'demo'
        },
        {
            text: 'Account Status',
            value: 'status',
            component_name: null,
            track_name: null,
            type: 'select',
            category: 'other'
        },
        {
            text: 'Prescribed Status',
            value: 'prescribed_status',
            component_name: null,
            track_name: null,
            type: 'select',
            category: 'other'
        },
        {
            text: 'Prescribed Status',
            value: 'prescribing_status',
            component_name: null,
            track_name: null,
            type: 'select',
            category: 'other'
        },
        {
            text: 'Gender',
            value: 'gender',
            component_name: null,
            track_name: null,
            type: 'select',
            category: 'demo'
        }
    ],
    SEGMENTATION_TABLES: [
        { 
            value: "doctor_mailing_lists", 
            text: "Doctors", 
            default_fields: [
                { key: "email", alias: "email" },
                { key: "contact_no", alias: "contact_no" }
            ] 
        },
        { 
            value: "dentist_mailing_lists", 
            text: "Dentists", 
            default_fields: [
                { key: "email", alias: "email" },
                { key: "contact_no", alias: "contact_no" }
            ]  
        },
        { 
            value: "patients", 
            text: "Patients", 
            default_fields: [
                { key: "email", alias: "email" },
                { key: "mobile_no", alias: "contact_no" }
            ]  
        },
        { 
            value: "pharmacist_mailing_lists", 
            text: "Pharmacists", 
            default_fields: [
                { key: "email", alias: "email" },
                { key: "mobile_no", alias: "contact_no" }
            ]  
        },
    ],
    PUSH_NOTIF_TYPES: [
        { value: "brand_info", text: "Brand Info", target: "brand" },
        { value: "chat", text: "Chat", target: null },
    ]
};

export const ADMETA = {
    KEYS: [
        { value: "page", text: "Page" },
        { value: "keyword", text: "Keyword" },
        { value: "specialty", text: "Specialty" },
        { value: "brand", text: "Brand" },
        { value: "treatment_guideline", text: "Treatment Guideline" }
    ],
    PAGES: [
        { value: "announcement", text: "Announcement" },
        { value: "appointments", text: "Appointments" },
        { value: "brand", text: "Brand" },
        { value: "company", text: "Company" },
        { value: "disease", text: "Disease" },
        { value: "generic", text: "Generic" },
        { value: "therapeutic_class", text: "Therapeutic Class" },
        { value: "transaction", text: "Transaction" },
        { value: "dashboard", text: "Dashboard" },
        { value: "messages", text: "Messages" },
        { value: "patients", text: "Patients" }
    ],
};

export const DOCTOR = {
    STATUS: [
        { value: "approved", text: "Approved" },              
        { value: "pending", text: "Pending" },        
        { value: "declined", text: "Declined" },
        { value: "for approval", text: "For Approval" },            
        { value: "for deletion", text: "For Deletion" }
    ],
    PRESCRIBED_STATUS: [
        { value: "approved", text: "Approved" },              
        { value: "pending", text: "Pending" },        
        { value: "declined", text: "Declined" },
        { value: "suspended", text: "Suspended" }
    ],
};

export const TICKET = {
    STATUS: [
        { value: 1, text: "Pending" }, 
        { value: 2, text: "Assigned" },
        { value: 3, text: "Closed" },
        { value: 4, text: "Ongoing" },
        { value: 5, text: "For Testing" },
        { value: 6, text: "Waiting for Reply" },
        { value: 7, text: "Resolved" },
        { value: 8, text: "Reopened" }
    ],
    PLATFORM: [
        { value: 1, slug: "ppd-app", text: "PPD App" },
        { value: 2, slug: "ppd-web", text: "PPD Web" },
        { value: 3, slug: "tfd-app", text: "TFD App" }, 
        { value: 4, slug: "tfd-web", text: "TFD Web" },
        { value: 5, slug: "ppd-internal", text: "PPD Internal" },
        { value: 6, slug: "ppd-teams", text: "PPD Teams" }
    ],
    PRIORITY: [
        { value: "low", text: "Low", color: "#FFD966" },              
        { value: "medium", text: "Medium", color: "#FB923C" },        
        { value: "high", text: "High", color: "#FF3333" },
    ],
    USER_TYPE: [
        { value: "doctor", text: "Doctor", color: "#007BFF" },
        { value: "dentist", text: "Dentist", color: "#17A2B8" },
        { value: "patient", text: "Patient", color: "#28A745" },
        { value: "pharmacist", text: "Pharmacist", color: "#563D7C" },
        { value: "admin", text: "Internal User", color: "#005E30" },
        { value: "tm_user", text: "Teams Allied", color: "#FFABEC" }
    ],
};

export const DEFAULT_OPTIONS = [
    { value: null, text: "All" },
    { value: 1, text: "Yes" },
    { value: 0, text: "No" }
]

export const DEFAULT_BOOLEAN_OPTIONS = [
    { value: null, text: "All" },
    { value: true, text: "Yes" },
    { value: false, text: "No" }
]

export const DISPLAY_OPTIONS = [
    { value: null, text: "All" },
    { value: "doctor", text: "Doctor" },
    { value: "patient", text: "Patient" }
]

export const GENDER_OPTIONS = [
    { value: null, text: "All" },
    { value: "male", text: "Male" },
    { value: "female", text: "Female" }
]

export const AGE_OPTIONS = [
    { value: null, text: "All" },
    { value: "infants", text: "Infants (Below 1yo)" },
    { value: "toddler", text: "Toddler and Pre-School (1-5yo)" },
    { value: "childhood", text: "Childhood (6-10yo)" },
    { value: "older_children", text: "Older Children (11-19yo)" },
    { value: "young_adults", text: "Young Adults (20-29yo)" },
    { value: "adults", text: "Adults (30-59yo)" },
    { value: "seniors", text: "Seniors (60yo and Above)" }
]

export const CIVIL_STATUS_OPTIONS = [
    { value: null, text: "All" },
    { value: "single", text: "Single" },              
    { value: "married", text: "Married" },        
    { value: "divorced", text: "Divorced" },
    { value: "separated", text: "Separated" },            
    { value: "widowed", text: "Widowed" }
]

export const APPOINTMENT_STATUS_OPTIONS = [
    { value: null, text: "All" },
    { value: "pending", text: "Pending" },
    { value: "accepted", text: "Accepted" },
    { value: "declined", text: "Declined" },
    { value: "served", text: "Served" },
    { value: "reschedule", text: "Reschedule" },
    { value: "cancelled", text: "Cancelled" },
    { value: "deleted", text: "Deleted" }
]

export const COMPANY_LISTING_TYPE_OPTIONS = [
    { value: "basic", text: "Basic Only", color: "info" },
    { value: "logo", text: "Bold Listing with Logo", color: "primary" },
    { value: "profile", text: "Bold Listing with Company Profile", color: "success" },
]

export const SORT_OPTIONS = [
    { value: "asc", text: "Asc" },
    { value: "desc", text: "Desc" }
]

export const LIMIT_OPTIONS = [
    { value: 10, text: "10" },
    { value: 20, text: "20" },
    { value: 50, text: "50" },
    { value: 100, text: "100" },
    { value: 200, text: "200" }
]

export const SCHEDULE_AVAILABILITY_OPTIONS = [
    { value: "", text: "" },
    { value: "By Appointment", text: "By Appointment" },
    { value: "Walk In", text: "Walk In" },
    { value: "Walk-In or By Appointment", text: "Walk-In or By Appointment" }
]

export const DOCTOR_CLINIC_AVAILABILITY_OPTIONS = [
    { value: null, text: "" },  
    { value: 0, text: "Consultant" },              
    { value: 1, text: "On Call" },              
    { value: 2, text: "Resident" },              
    { value: 3, text: "Visiting" },              
    { value: 4, text: "Fellow" }
]

export const DOCUMENT_TYPE_OPTIONS = [
    { value: "document", text: "Document" },              
    { value: "image", text: "Image" }
]


export const DISEASE = {
    DISEASE_TYPE_OPTIONS: [
        { value: "acute", text: "Acute" },         
        { value: "chronic", text: "Chronic" }
    ]
}